import { render, staticRenderFns } from "./PraticeExplanatoryTopicsSection.vue?vue&type=template&id=ebd77b60"
import script from "./PraticeExplanatoryTopicsSection.vue?vue&type=script&lang=ts"
export * from "./PraticeExplanatoryTopicsSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeExplanatoryTopicsSection.vue?vue&type=style&index=0&id=ebd77b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports